import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { 
  Container, 
  Paper, 
  Typography, 
  Button, 
  Box,
  Card,
  CardContent,
  CardActions,
  Grid,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  AppBar,
  Toolbar,
  Divider,
  CssBaseline,
  IconButton
} from '@mui/material';
import './index.css';
import PumpApp from './pump';
import FenfaApp from './fenfa';
import ceshi from './hg';
import BAOBINGV2 from './V2';
import ETH from './eth';
import fist from './fist';
import { styled, useTheme } from '@mui/material/styles';

// 导入图标
import HomeIcon from '@mui/icons-material/Home';
import SendIcon from '@mui/icons-material/Send';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import MenuIcon from '@mui/icons-material/Menu';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import HelpIcon from '@mui/icons-material/Help';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

// 导入logo图片
import logoImage from './image.png'; // 确保在src目录下有这个图片
// 如果没有图片，可以使用一个简单的文本作为临时替代

// 创建全局样式函数
const setupGlobalStyles = () => {
  const globalStyles = `
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  `;

  if (typeof document !== 'undefined' && !document.getElementById('global-styles')) {
    const styleTag = document.createElement('style');
    styleTag.id = 'global-styles';
    styleTag.innerHTML = globalStyles;
    document.head.appendChild(styleTag);
  }
};

// 创建HomeComponent作为独立的React组件
const HomeComponent = () => {
  // 在组件内部使用hooks获取价格数据
  const [tokenPrices, setTokenPrices] = useState({
    BTC: { price: '$0', change: '0%' },
    ETH: { price: '$0', change: '0%' },
    BNB: { price: '$0', change: '0%' },
    DOGE: { price: '$0', change: '0%' },
    SHIB: { price: '$0', change: '0%' },
    SOL: { price: '$0', change: '0%' }
  });
  
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // 定义代币ID映射（CoinGecko API使用的ID）
  const tokenIds = {
    BTC: 'bitcoin',
    ETH: 'ethereum',
    BNB: 'binancecoin',
    DOGE: 'dogecoin',
    SHIB: 'shiba-inu',
    SOL: 'solana'
  };
  
  // 格式化价格函数
  const formatPrice = (price) => {
    return price >= 1 
      ? `$${parseFloat(price).toFixed(2)}`
      : `$${parseFloat(price).toFixed(6)}`;
  };
  
  // 生成模拟数据（解决CORS问题）
  const getMockData = () => {
    // 生成20%范围内随机波动的价格
    const mockPrices = {
      BTC: { price: formatPrice(28420 + Math.random() * 1000 - 500), change: `${(Math.random() * 10 - 5).toFixed(2)}%`, changeValue: Math.random() * 10 - 5 },
      ETH: { price: formatPrice(1580 + Math.random() * 100 - 50), change: `${(Math.random() * 8 - 4).toFixed(2)}%`, changeValue: Math.random() * 8 - 4 },
      BNB: { price: formatPrice(230 + Math.random() * 20 - 10), change: `${(Math.random() * 6 - 3).toFixed(2)}%`, changeValue: Math.random() * 6 - 3 },
      DOGE: { price: formatPrice(0.08 + Math.random() * 0.01 - 0.005), change: `${(Math.random() * 12 - 6).toFixed(2)}%`, changeValue: Math.random() * 12 - 6 },
      SHIB: { price: formatPrice(0.000008 + Math.random() * 0.000001 - 0.0000005), change: `${(Math.random() * 14 - 7).toFixed(2)}%`, changeValue: Math.random() * 14 - 7 },
      SOL: { price: formatPrice(75 + Math.random() * 8 - 4), change: `${(Math.random() * 10 - 5).toFixed(2)}%`, changeValue: Math.random() * 10 - 5 }
    };
    return mockPrices;
  };
  
  // 获取代币价格数据
  const fetchTokenPrices = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      // 选项1: 使用模拟数据（在本地开发环境中工作）
      const mockData = getMockData();
      setTokenPrices(mockData);
      
      // 选项2: 使用CORS代理（需要设置）
      /*
      // 构建代币ID列表
      const ids = Object.values(tokenIds).join(',');
      
      // 使用CORS代理服务
      const corsProxy = 'https://cors-anywhere.herokuapp.com/'; // 需要先访问 https://cors-anywhere.herokuapp.com/corsdemo 获取临时访问权限
      const apiUrl = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=${ids}&order=market_cap_desc&per_page=100&page=1&sparkline=false&price_change_percentage=24h`;
      
      const response = await fetch(corsProxy + apiUrl);
      
      if (!response.ok) {
        throw new Error('价格数据获取失败');
      }
      
      const data = await response.json();
      
      // 处理获取的数据
      const newPrices = { ...tokenPrices };
      
      data.forEach(token => {
        // 找出币种对应的符号
        const symbol = Object.keys(tokenIds).find(key => tokenIds[key] === token.id);
        
        if (symbol) {
          newPrices[symbol] = {
            price: formatPrice(token.current_price),
            change: `${token.price_change_percentage_24h.toFixed(2)}%`,
            changeValue: token.price_change_percentage_24h
          };
        }
      });
      
      setTokenPrices(newPrices);
      */
      
      // 选项3: 如果你有自己的后端服务器，可以通过后端代理请求
      /*
      const response = await fetch('/api/crypto-prices'); // 你的后端API路径
      const data = await response.json();
      setTokenPrices(data);
      */
    } catch (err) {
      console.error('获取代币价格失败:', err);
      setError('获取价格数据失败，使用模拟数据');
      
      // 出错时使用模拟数据
      const mockData = getMockData();
      setTokenPrices(mockData);
    } finally {
      setIsLoading(false);
    }
  };
  
  // 组件加载时获取价格数据，并设置30秒刷新间隔（模拟数据可以更频繁刷新）
  useEffect(() => {
    fetchTokenPrices();
    
    // 设置定时刷新（30秒，因为是模拟数据）
    const intervalId = setInterval(fetchTokenPrices, 30 * 1000);
    
    // 组件卸载时清除定时器
    return () => clearInterval(intervalId);
  }, []);

  // 组件加载时注入全局样式
  useEffect(() => {
    setupGlobalStyles();
  }, []);
  
  // 构建显示的币种数据
  const coinData = [
    { symbol: 'BTC', name: 'BTC / USDT', price: tokenPrices.BTC.price, change: tokenPrices.BTC.change, changeValue: tokenPrices.BTC.changeValue },
    { symbol: 'ETH', name: 'ETH / USDT', price: tokenPrices.ETH.price, change: tokenPrices.ETH.change, changeValue: tokenPrices.ETH.changeValue },
    { symbol: 'BNB', name: 'BNB / USDT', price: tokenPrices.BNB.price, change: tokenPrices.BNB.change, changeValue: tokenPrices.BNB.changeValue },
    { symbol: 'DOGE', name: 'DOGE / USDT', price: tokenPrices.DOGE.price, change: tokenPrices.DOGE.change, changeValue: tokenPrices.DOGE.changeValue },
    { symbol: 'SHIBA', name: 'SHIB / USDT', price: tokenPrices.SHIB.price, change: tokenPrices.SHIB.change, changeValue: tokenPrices.SHIB.changeValue },
    { symbol: 'SOL', name: 'SOL / USDT', price: tokenPrices.SOL.price, change: tokenPrices.SOL.change, changeValue: tokenPrices.SOL.changeValue }
  ];
  
  return (
    <Container maxWidth="lg" sx={{ mt: 3, mb: 4 }}>
      {error && (
        <Paper sx={{ p: 2, mb: 3, backgroundColor: '#ffebee' }}>
          <Typography color="error">{error}</Typography>
        </Paper>
      )}
      
      <Grid container spacing={3}>
        {coinData.map((coin, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper
              elevation={2}
              sx={{
                p: 2,
                display: 'flex',
                alignItems: 'center',
                borderRadius: 2,
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              {isLoading && (
                <Box sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '2px',
                  background: 'linear-gradient(90deg, transparent, #2196f3, transparent)',
                  animation: 'loading 1.5s infinite'
                }} />
              )}
              <Box sx={{
                marginRight: '15px',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 'bold'
              }}>
                {coin.symbol.charAt(0)}
              </Box>
              <Box>
                <Typography variant="h6">{coin.name}</Typography>
                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>{coin.price}</Typography>
                <Typography 
                  color={parseFloat(coin.change) >= 0 ? 'success.main' : 'error.main'} 
                  variant="body2"
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  {parseFloat(coin.change) >= 0 ? '↑' : '↓'} {coin.change}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom>
              FHD工具介绍
            </Typography>
            <Typography variant="body2">
              这是一个Web3.0多链工具平台，提供各种币种交易工具、代币创建工具、批量转账工具等产品。即便不懂编程的小白用户，也能在本平台上轻松完成各种操作。
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom>
              实用工具
            </Typography>
            <Button variant="outlined" sx={{ mb: 1, width: '100%' }}>
              <SwapHorizIcon sx={{ mr: 1 }} /> 跨链闪兑
            </Button>
            <Button variant="outlined" sx={{ mb: 1, width: '100%' }}>
              <SendIcon sx={{ mr: 1 }} /> Solana发币
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom>
              第三方链接
            </Typography>
            <Button variant="outlined" sx={{ mb: 1, width: '100%' }}>
              <LocalFireDepartmentIcon sx={{ mr: 1 }} /> 粉红预售
            </Button>
            <Button variant="outlined" sx={{ mb: 1, width: '100%' }}>
              <HelpIcon sx={{ mr: 1 }} /> 帮助文档
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

// 应用配置
const APP_CONFIG = [
 
  
  /**{
    id: 'fist',
    name: 'fist底池市值工具',
    icon: <AccountBalanceWalletIcon />,
    component: fist,
    description: 'fist批量市值机器人'
  },
  {
    id: 'FenfaApp',
    name: '批量工具',
    icon: <AccountBalanceWalletIcon />,
    component: FenfaApp,
    description: '批量工具'
  },
  {
    id: 'ceshi',
    name: '批量工具',
    icon: <AccountBalanceWalletIcon />,
    component: ceshi,
    description: '批量工具'
  },**/
  {
    id: 'PumpApp',
    name: 'FHD FOUR内盘市值工具',
    icon: <AccountBalanceWalletIcon />,
    component: PumpApp,
    description: 'FHD FOUR内盘市值工具值机器人'
  },
  {
    id: 'BAOBINGV2',
    name: 'FHD V2池子批量市值工具',
    icon: <AccountBalanceWalletIcon />,
    component: BAOBINGV2,
    description: 'FHD V2池子批量市值工具'
  },
  {
    id: 'ETH',
    name: 'FHD ETH批量市值工具',
    icon: <AccountBalanceWalletIcon />,
    component: ETH,
    description: 'ETH批量市值工具'
  }, {
    id: 'FenfaApp',
    name: 'FHD 批量工具',
    icon: <AccountBalanceWalletIcon />,
    component: FenfaApp,
    description: 'FHD 批量工具'
  },
  {
    id: 'sol',
    name: 'FHD SOL内外盘市值工具',
    icon: <AccountBalanceWalletIcon />,
    link: 'http://sol.clainfreesol.site/botv8/zh.html',
    description: 'FHD sol内外盘市值工具',
    isExternal: true
  }
  
];

// 抽屉宽度
const drawerWidth = 240;

// 样式化的组件
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // 必要的占位符，让内容位于AppBar下方
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

// 打开状态的抽屉样式
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

// 关闭状态的抽屉样式
const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

// 主应用组件
const App = () => {
  const theme = useTheme();
  const [currentAppId, setCurrentAppId] = useState('home');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [walletConnected, setWalletConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState('0x7db...edf0b');

  // 组件挂载时注入全局样式
  useEffect(() => {
    setupGlobalStyles();
  }, []);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  // 修改菜单项点击处理函数
  const handleMenuItemClick = (appId) => {
    const app = APP_CONFIG.find(app => app.id === appId);
    if (app && app.isExternal && app.link) {
      // 如果是外部链接，在新窗口打开
      window.open(app.link, '_blank');
    } else {
      // 否则切换到对应的组件
      setCurrentAppId(appId);
    }
    setDrawerOpen(false);
  };

  const handleConnectWallet = () => {
    setWalletConnected(true);
  };

  const currentApp = APP_CONFIG.find(app => app.id === currentAppId);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          ...(drawerOpen && {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
          backgroundColor: 'white',
          color: 'black',
          boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.05)',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label={drawerOpen ? "close drawer" : "open drawer"}
            onClick={drawerOpen ? handleDrawerClose : handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 2,
              ...(drawerOpen && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1 }}
          >
            {currentApp ? currentApp.name : 'Home'}
          </Typography>
          <Button
            variant={walletConnected ? "outlined" : "contained"}
            color={walletConnected ? "primary" : "primary"}
            startIcon={<AccountBalanceWalletIcon />}
            onClick={handleConnectWallet}
          >
            {walletConnected ? walletAddress : "连接钱包"}
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        open={drawerOpen}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          boxSizing: 'border-box',
          ...(drawerOpen ? {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
          } : {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
          }),
          '& .MuiDrawer-paper': {
            backgroundColor: '#f8f9fa',
            borderRight: '1px solid #e0e0e0'
          }
        }}
      >
        <Box
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            padding: theme.spacing(1, 1),
            ...theme.mixins.toolbar,
            justifyContent: drawerOpen ? 'space-between' : 'center',
            borderBottom: '1px solid #e0e0e0'
          }}
        >
          {drawerOpen ? (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img 
                  src={logoImage} 
                  alt="Logo" 
                  style={{ height: 24, marginRight: 8 }} 
                />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Bot Tool
                </Typography>
              </Box>
              <IconButton onClick={handleDrawerClose} size="small">
                <ChevronLeftIcon />
              </IconButton>
            </>
          ) : (
            <img 
              src={logoImage} 
              alt="Logo" 
              style={{ height: 24 }} 
            />
          )}
        </Box>
        <List sx={{ mt: 1 }}>
          {APP_CONFIG.map((app) => (
            <ListItem 
              key={app.id}
              sx={{
                display: 'block',
                mb: 0.5,
                mx: 1,
                px: 1,
                borderRadius: '8px',
                '&.Mui-selected': {
                  backgroundColor: 'rgba(25, 118, 210, 0.08)',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: 'rgba(25, 118, 210, 0.12)',
                },
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                }
              }}
              selected={currentAppId === app.id}
              onClick={() => handleMenuItemClick(app.id)}
              component="div"
              disablePadding
            >
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                py: 1.5,
                pl: drawerOpen ? 1 : 0,
                justifyContent: drawerOpen ? 'flex-start' : 'center',
                cursor: 'pointer'
              }}>
                <Box sx={{ 
                  color: currentAppId === app.id ? 'primary.main' : 'text.secondary',
                  minWidth: drawerOpen ? 36 : 'auto',
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                  {app.icon}
                </Box>
                {drawerOpen && (
                  <Typography 
                    sx={{ 
                      ml: 2, 
                      fontWeight: currentAppId === app.id ? 'medium' : 'normal',
                      color: currentAppId === app.id ? 'primary.main' : 'text.primary'
                    }}
                  >
                    {app.name}
                  </Typography>
                )}
              </Box>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          width: '100%',
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
        }}
      >
        <DrawerHeader />
        {currentApp && !currentApp.isExternal && currentApp.component && 
          React.createElement(currentApp.component)
        }
        {currentAppId === 'home' && <HomeComponent />}
      </Box>
    </Box>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
